export const SALARY_CURRENCIES = [
  { code: "NGN", label: "NGN — Nigerian Naira" },
  { code: "USD", label: "USD — US Dollar" },
  { code: "GBP", label: "GBP — British Pound" },
  { code: "EUR", label: "EUR — Euro" },
  { code: "KES", label: "KES — Kenyan Shilling (M-PESA)" },
  { code: "GHS", label: "GHS — Ghanaian Cedi (MoMo)" },
  { code: "UGX", label: "UGX — Ugandan Shilling (Mobile Money)" },
  { code: "TZS", label: "TZS — Tanzanian Shilling (M-PESA)" },
  { code: "RWF", label: "RWF — Rwandan Franc (Mobile Money)" },
  { code: "XOF", label: "XOF — West African CFA (Orange/MTN Money)" },
  { code: "XAF", label: "XAF — Central African CFA (Mobile Money)" },
  { code: "ZMW", label: "ZMW — Zambian Kwacha (Mobile Money)" },
  { code: "MWK", label: "MWK — Malawian Kwacha (Mobile Money)" },
  { code: "ZAR", label: "ZAR — South African Rand" },
  { code: "EGP", label: "EGP — Egyptian Pound" },
]
